const AUDIT_FIELDS = ["createdAt", "createdBy", "updatedAt", "updatedBy"];
const TEMPLATE_ONLY_FIELDS = ["partitionKey", "companyCode", "publishedAt", "publishedBy"];

const stripFields = (item, fields) => {
  if (!item || typeof item !== "object") return item;
  const rest = { ...item };
  fields.forEach((field) => delete rest[field]);
  return rest;
};

const stripMilestone = (milestone) => {
  const rest = stripFields(milestone, AUDIT_FIELDS);
  if (Array.isArray(rest.childMilestones)) {
    rest.childMilestones = rest.childMilestones.map(stripMilestone);
  }
  return rest;
};

// Removes data the server owns (audit fields, partition key, company, publish info) from the
// PATCH payload; the server reads these from the stored template.
export function toProjectTemplatePayload(projectTemplate) {
  if (!projectTemplate) return projectTemplate;

  const rest = stripFields(projectTemplate, AUDIT_FIELDS.concat(TEMPLATE_ONLY_FIELDS));

  if (Array.isArray(rest.milestones)) {
    rest.milestones = rest.milestones.map(stripMilestone);
  }

  return rest;
}
